"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Label = _interopRequireDefault(require("./Label"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const FieldOptionWrapper = _styledComponents.default.div.withConfig({
  displayName: "FieldOption__FieldOptionWrapper",
  componentId: "design-system__sc-3hash9-0"
})(["display:flex;align-items:flex-start;input + label{padding:0;}& + .FieldOption{margin-top:1.5rem;}.text{margin-left:0.8rem;label{padding:0;margin:5px 0 0.8rem;}span{color:", ";font-size:", ";font-family:", ";display:block;}}"], _BaseTheme.default.colors.lightgray, _BaseTheme.default.type.size.small, _BaseTheme.default.type.family.system);

const FieldOption = _ref => {
  let {
    children,
    label,
    id,
    description
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(FieldOptionWrapper, {
    className: "FieldOption"
  }, children, /*#__PURE__*/_react.default.createElement("div", {
    className: "text"
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    htmlFor: id
  }, label), /*#__PURE__*/_react.default.createElement("span", null, description)));
};

FieldOption.propTypes = {
  children: _propTypes.default.element.isRequired,
  label: _propTypes.default.string.isRequired,
  id: _propTypes.default.string.isRequired,
  description: _propTypes.default.string
};
FieldOption.defaultProps = {
  description: ''
};
var _default = FieldOption;
exports.default = _default;